document.addEventListener('DOMContentLoaded' , () =>{
    // product - product-lists-page
    if(document.querySelector('.product-lists-page')){
        $('.prd-visual').slick({
			lazyLoad: 'ondemand',
            dots:true,
            arrows:false,
            autoplay:true,
        });
    }

    // product - product-lists-page
    if(document.querySelector('.event-product-lists-page')){
        $('.prd-visual').slick({
            dots:true,
            arrows:true
        });
    }

    // product - product-view-page
    if(document.querySelector('.product-view-page')){
        $('.prd-visual').slick({
            dots:true,
            arrows:false
        });
        
        const btnInfo = document.querySelector('.btn-info');
        btnInfo.addEventListener('click' , function(){
            btnInfo.classList.toggle('active');
        });

        const viewPage = document.querySelector('.product-view-page');
        console.log(viewPage);
        // document.querySelector('.js_wish')

        const detailedInfo = viewPage.querySelector('.detailed-info__img_info');
        console.log(detailedInfo);
        console.log(viewPage.querySelector('.js_viewInfo'));
        viewPage.querySelector('.js_viewInfo').addEventListener('click', function(){
            detailedInfo.classList.add('active');
        });

        const buyProcess = viewPage.querySelector('.buy-process');
        viewPage.querySelector('.js_showOption').addEventListener('click', function(){
            buyProcess.classList.add('active');
        });
        viewPage.querySelector('.js_closeOption').addEventListener('click', function(){
            buyProcess.classList.remove('active');
        });
    }

    if(document.querySelector('.member-grade')){
        const memberGradeBtn = document.querySelector('.js_member_grade');
              memberGrade = document.querySelector('.member-grade');

        memberGradeBtn.addEventListener('click', function(){
            memberGradeBtn.classList.toggle('active');
            memberGrade.classList.toggle('active');
        });
    }

    // js_prd_swiper
    if(document.querySelector('.js_prd_swiper')){
        let prdSwiper = document.querySelectorAll('.js_prd_swiper');

        prdSwiper.forEach(function(el){
            let swiper = new Swiper(el, {
				slidesPerView: 'auto',
                spaceBetween: 1,
            });
        })
    }

    // best-product-lists-page
    if(document.querySelector('.best-product-lists-page')){
        let swiper = new Swiper('.sub-category', {
            slidesPerView: 'auto',
            spaceBetween: 5,
        });

        // design-toggle
        let dsgToggleBtn = document.querySelectorAll('.design-toggle__btn');
        
        dsgToggleBtn.forEach(function(el){
            let dsgToggleBtnArray = Array.from(el.parentNode.parentNode.querySelectorAll('.design-toggle__btn'));

            el.addEventListener('click' , function(e){
                dsgToggleBtnArray.forEach(function(el){
                    el.classList.remove('active');
                });
                el.classList.add('active');
            });
        })
    }
});
